module.exports = require("chalk");